import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  FormControl,
  MenuItem,
  Select,
  TextField,
  useTheme,
  Typography,
  Grid,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const ProviderFilter = ({ sortBy, setSortBy, setFilterText }) => {
  const [searchInput, setSearchInput] = useState("");
  const theme = useTheme();

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
    setFilterText(event.target.value);
  };

  const handleClear = () => {
    setSearchInput("");
    setFilterText("");
  };

  return (
    <Card
      sx={{
        mb: 1.5,
        width: "100%",
        borderRadius: 1,
      }}
      elevation={0}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "8px 12px",
          width: "100%",
          gap: 1.5,
        }}
      >
        <Grid container spacing={1.5}>
          <Grid item xs={12}>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 500,
                color: "text.secondary",
                mb: 0.5,
                display: "block",
              }}
            >
              Name
            </Typography>
            <TextField
              fullWidth
              value={searchInput}
              onChange={handleSearchInputChange}
              placeholder="Filter by name"
              variant="outlined"
              size="small"
              InputProps={{
                sx: {
                  backgroundColor: "background.input",
                  "& .MuiOutlinedInput-input": {
                    padding: "6px 10px",
                  },
                },
                endAdornment: searchInput && (
                  <IconButton
                    size="small"
                    onClick={handleClear}
                    sx={{ marginRight: -1 }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};

export default ProviderFilter;
